"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _linkaddress = _interopRequireDefault(require("@/components/linkaddress"));
var _systemSetting = require("@/api/systemSetting.js");
var _companyappApi = require("@/api/companyappApi");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  components: {
    LinkaddressVue: _linkaddress.default
  },
  data: function data() {
    return {
      form: {},
      userType: null,
      customerList: [],
      rules: {
        type: [{
          required: true,
          type: 'number',
          message: '请选择页面类型',
          trigger: 'change'
        }],
        pageType: [{
          required: true,
          validator: function validator(rule, value, callback) {
            if (value === undefined || value === null || value === '') {
              callback(new Error('请选择来一票京东/山姆'));
            } else {
              callback();
            }
          },
          trigger: 'change'
        }],
        name: [{
          required: true,
          message: '请输入页面名称',
          trigger: 'blur'
        }],
        title: [{
          required: true,
          message: '请输入页面标题',
          trigger: 'blur'
        }],
        duration: [{
          required: true,
          message: '请输入广告时间',
          trigger: 'blur'
        }],
        advUrl: [{
          required: true,
          message: '请选择跳转链接',
          trigger: 'change'
        }],
        adInterval: [{
          required: true,
          message: '请输入间隔时间',
          trigger: 'blur'
        }]
      },
      pageTypeEnum: [{
        label: '首页',
        value: 1
      }, {
        label: '专题页',
        value: 2
      }, {
        label: '共享页',
        value: 3
      }, {
        label: '权益卡包兑换页',
        value: 4
      }, {
        label: '游客首页',
        value: 5
      }],
      pageDisplayTypeEnum: [{
        label: '普通页面',
        value: 0
      }, {
        label: '来一票京东',
        value: 1
      }, {
        label: '来一票山姆',
        value: 2
      }]
    };
  },
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  watch: {
    value: {
      handler: function handler() {
        var _this = this;
        var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var hasPageType = val && val.pageType != null;
        var hasType = val && val.type != null;
        var hasCanLogin = val && val.canLogin != null;
        var canLogin = hasCanLogin && (val.canLogin === true || Number(val.canLogin) === 1) ? 1 : 0;
        this.form = _objectSpread(_objectSpread({}, val), {}, {
          type: hasType ? Number(val.type) : hasPageType ? Number(val.pageType) : 0,
          pageType: hasPageType ? Number(val.pageType) : 0,
          canLogin: canLogin
        });
        this.enforceMiniProgramCustomerPageType();
        // 旧数据未配置 pageType 时，初始化即回写默认值，确保不编辑也能正确提交
        if (!hasPageType && !hasType || !hasCanLogin) {
          this.$nextTick(function () {
            _this.updateForm();
          });
        }
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    isMiniProgramCustomer: function isMiniProgramCustomer() {
      return Number(this.userType) === 5;
    },
    availablePageTypeEnum: function availablePageTypeEnum() {
      if (this.isMiniProgramCustomer) {
        return this.pageTypeEnum.filter(function (item) {
          return item.value === 2;
        });
      }
      return this.pageTypeEnum;
    }
  },
  mounted: function mounted() {
    try {
      var JavaInfo = JSON.parse(_jsCookie.default.get('JavaInfo'));
      this.userType = JavaInfo.type;
    } catch (e) {
      this.userType = null;
    }
    this.loadCustomerList();
    this.enforceMiniProgramCustomerPageType();
  },
  methods: {
    enforceMiniProgramCustomerPageType: function enforceMiniProgramCustomerPageType() {
      if (!this.isMiniProgramCustomer) return;
      if (Number(this.form.type) !== 2) {
        this.$set(this.form, 'type', 2);
        this.updateForm();
      }
    },
    loadCustomerList: function () {
      var _loadCustomerList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return (0, _companyappApi.customersListApi)({
                types: 3
              });
            case 1:
              res = _context.v;
              this.customerList = res || [];
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              this.customerList = [];
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function loadCustomerList() {
        return _loadCustomerList.apply(this, arguments);
      }
      return loadCustomerList;
    }(),
    blockInvalidNumberKey: function blockInvalidNumberKey(e) {
      if (['e', 'E', '+', '-'].includes(e.key)) {
        e.preventDefault();
      }
    },
    validate: function validate() {
      var _this2 = this;
      return new Promise(function (resolve) {
        _this2.$refs.baseForm.validate(function (valid) {
          return resolve(valid);
        });
      });
    },
    updateForm: function updateForm() {
      this.$emit("input", this.form);
    },
    modalPicTap: function modalPicTap(tit, type) {
      var _this3 = this;
      this.$modalUpload(function (img) {
        _this3.$set(_this3.form, type, img[0].sattDir);
        _this3.updateForm();
      }, tit, 'system');
    },
    removeImg: function removeImg(type) {
      this.$set(this.form, type, '');
      this.updateForm();
    },
    beforeUpload: function beforeUpload(file) {
      var isImage = file.type.indexOf('image/') === 0;
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isImage) {
        this.$message.error('只能上传图片文件！');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('图片大小不能超过 2MB！');
        return false;
      }
      return true;
    },
    handleLocalUpload: function () {
      var _handleLocalUpload = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(options, fieldName) {
        var file, formData, params, loading, res, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              file = options.file;
              formData = new FormData();
              formData.append('multipart', file);
              params = {
                model: 'product',
                pid: 1
              };
              loading = this.$loading({
                lock: true,
                text: '上传中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
              _context2.p = 1;
              _context2.n = 2;
              return (0, _systemSetting.fileImageApi)(formData, params);
            case 2:
              res = _context2.v;
              loading.close();
              if (res && res.url) {
                this.$set(this.form, fieldName, res.url);
                this.updateForm();
                this.$message.success('上传成功');
              } else {
                this.$message.error('上传失败，请重试');
              }
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t2 = _context2.v;
              loading.close();
              this.$message.error('上传失败：' + (_t2.message || '请重试'));
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 3]]);
      }));
      function handleLocalUpload(_x, _x2) {
        return _handleLocalUpload.apply(this, arguments);
      }
      return handleLocalUpload;
    }()
  }
};